import { render, staticRenderFns } from "./ModalCotization.vue?vue&type=template&id=3064277d&scoped=true&lang=pug"
import script from "./ModalCotization.vue?vue&type=script&lang=js"
export * from "./ModalCotization.vue?vue&type=script&lang=js"
import style0 from "./ModalCotization.vue?vue&type=style&index=0&id=3064277d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3064277d",
  null
  
)

export default component.exports